export default __webpack_public_path__ + "static/media/folder-plus.e573ef14.svg";